import React from 'react';

const DownArrow = () => (
  <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.175 0L5 3.81668L8.825 0L10 1.175L5 6.17502L0 1.175L1.175 0Z" fill="#505050" />
  </svg>
);

export default DownArrow;
